module.exports = __webpack_public_path__ + "img/img26.894707a5.png";